import { Redirect } from '#app/components/Redirect/index.js';
import { useToast } from '#app/components/Toasts/hooks/useToast.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useMount } from '@contra/react-hooks/useMount';
import { getRoute } from '@contra/routes';

export const Page = () => {
  const currentUser = useCurrentUser();
  const toast = useToast();

  useMount(() => {
    if (currentUser) {
      toast(
        'Editing your profile has moved! Try hovering over any of your information to give it a try.',
        { role: 'status' },
      );
    }
  });

  if (currentUser) {
    return (
      <Redirect
        method="push"
        to={getRoute('/@username', {
          args: { username: currentUser.profile.displayUsername },
        })}
      />
    );
  }

  return (
    <Redirect
      method="replace"
      to={getRoute('/')}
    />
  );
};
